export default __webpack_public_path__ + "static/media/metamask.3e732ef7.webp";